<template>
    <div v-if="step > 1 && step < 4">
        <div v-if="station">{{ t('station') }}: <strong>{{ station.name }}</strong></div>
        <div v-if="step > 2">{{ t('when') }}: <strong>{{ dateAndTime }}</strong></div>
    </div>
    <div v-else-if="step === 4" class="complete">
        <h2 class="h2">{{ t('summary') }}</h2>
        <p>{{ t('paymentOnLocation') }}</p>
        <p>{{ t('orderIsConfirmed') }}</p>

        <h3 class="h4">{{ t('whenAndWhere') }}</h3>
        <div>{{ t('station') }}:</div>
        <address v-if="station">
            <strong>{{ station.name }}</strong>
            <strong>{{ station.street }}, {{ station.postcode }} <span class="city">{{ station.city?.toLowerCase() }}</span></strong>
            <strong>{{ station.telephone }}</strong>
        </address>
        <div>{{ t('order') }}:</div>
        <ul>
            <li v-for="(item, key) in selectedProducts" :key="`product-${key}`">
                <strong>{{ item }}</strong>
            </li>
        </ul>
        <template v-if="order.data.value.comments">
            <div>{{ t('additionalInfo') }}:</div>
            <strong>{{ order.data.value.comments }}</strong>
        </template>
        <div>{{ t('pickupTime') }}:</div>
        <strong>{{ dateAndTime }}</strong>

        <h3 class="h4">{{ t('step3.title') }}</h3>
        <div>{{ t('contactPerson') }}:</div>
        <strong>{{ order.data.value.contact }}</strong>
        <div>{{ t('phone') }}:</div>
        <strong>{{ order.data.value.phone }}</strong>
        <div>{{ t('email') }}:</div>
        <strong>{{ order.data.value.email }}</strong>
    </div>
</template>
<script setup>
import { computed, inject, useI18n } from '#imports';

const order = inject('order');

const props = defineProps({
    step: {
        type: Number,
        required: false,
        default: 0,
    },
    station: {
        type: [Object, null],
        required: false,
        default: null,
    },
    dateString: {
        type: [String, null],
        required: false,
        default: null,
    },
    selectedProducts: {
        type: [Array, null],
        required: false,
        default: null,
    },
});

const dateAndTime = computed(() => {
    if (!props.dateString || !order.data.value.time) return '';

    return `${props.dateString}, ${order.data.value.time}`;
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            summary: 'Yhteenveto',
            station: 'Asema',
            when: 'Milloin',
            whenAndWhere: 'Missä ja milloin',
            order: 'Tilaus',
            additionalInfo: 'Lisätiedot',
            pickupTime: 'Noutoaika',
            contactPerson: 'Yhteyshenkilö',
            phone: 'Puhelinnumero',
            email: 'Sähköposti',
        },
    },
});
</script>
<style scoped>
.h2 {
  margin-bottom: 0.25rem;
}

.h4 {
  margin-bottom: 0.25rem;
}

.city {
  text-transform: capitalize;
}

.complete {
  margin-bottom: 1rem;
}
.complete strong {
  display: block;
  margin-bottom: 0.75rem;
}
</style>
